import axios from 'axios';
import Cookies from 'js-cookie';

const API_BASE_URL = 'https://staff.praxisamring-hameln.de';

// Get auth token from cookies
const getAuthToken = () => {
  return (
    localStorage.getItem('authToken') ||
    Cookies.get('jwtToken') ||
    null
  );
};

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Authorization': `Bearer ${getAuthToken()}`,
    'Content-Type': 'application/json',
  },
});

// News service methods
export const newsService = {
  // Get all news
  getAllNews: async () => {
    try {
      const response = await apiClient.get('/news/news');
      return response.data;
    } catch (error) {
      console.error('Error fetching news:', error);
      throw error;
    }
  },

  // Get single news by ID
  getNewsById: async (id) => {
    try {
      const response = await apiClient.get(`/news/news/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching news:', error);
      throw error;
    }
  },

  // Create new news
  createNews: async (newsData) => {
    try {
      const response = await apiClient.post('/news/add-news', newsData);
      return response.data;
    } catch (error) {
      console.error('Error creating news:', error);
      throw error;
    }
  },

  // Update news
  updateNews: async (id, newsData) => {
    try {
      const response = await apiClient.put(`/news/update-news/${id}`, newsData);
      return response.data;
    } catch (error) {
      console.error('Error updating news:', error);
      throw error;
    }
  },

  // Delete news
  deleteNews: async (id) => {
    try {
      const response = await apiClient.delete(`/news/delete-news/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting news:', error);
      throw error;
    }
  },

  deleteAllNews: async () => {
    try {
      const response = await apiClient.delete('/news/delete-all-news');
      return response.data;
    } catch (error) {
      console.error('Error deleting all news:', error);
      throw error;
    }
  },
}; 